const Footer = () => {
  return (
    <div className="flex  justify-center items-center my-5 text-[#9ca3af] text-center">

      Designed & Developed by&ensp;
      <a href="http://tarunbommali.vercel.app/" target="_blank" rel="noopener noreferrer" className="text-green-500" >
        Tarun Bommali
      </a>

    </div >
  );
};

export default Footer;
